import React, { useEffect, useLayoutEffect, useRef, useState, } from "react";
import {
    Col,
    Input,
    Label,
    Row,
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import { BreadcrumbShowCountlabel, commonPageFieldSuccess, getpdfReportdata, postOrderConfirms_API, postOrderConfirms_API_Success, postSelect_Field_for_dropdown } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { commonPageField } from "../../../store/actions";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    initialFiledFunc,
    onChangeDate,
    onChangeSelect,
} from "../../../components/Common/validationFunction";
import Select from "react-select";
import { SaveAndDownloadPDF, SaveButton } from "../../../components/Common/CommonButton";
import * as mode from "../../../routes/PageMode";
import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url"
import {
    GoButtonForinvoiceAddSuccess,
    Uploaded_EInvoiceAction,
    invoiceSaveActionSuccess,
    makeIB_InvoiceActionSuccess,
    editInvoiceActionSuccess,
    updateInvoiceActionSuccess,
    invoiceSaveAction
} from "../../../store/Sales/Invoice/action";
import { GetVenderSupplierCustomer, GetVenderSupplierCustomerSuccess } from "../../../store/CommonAPI/SupplierRedux/actions";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import {
    invoice_discountCalculate_Func,
    settingBaseRoundOffAmountFunc,
} from "../../Sale/Invoice/invoiceCaculations";
import "../../Sale/Invoice/invoice.scss"
import * as _cfunc from "../../../components/Common/CommonFunction";
import { CInput, C_DatePicker, C_Select, decimalRegx, } from "../../../CustomValidateForm";
import { getVehicleList, getVehicleListSuccess } from "../../../store/Administrator/VehicleRedux/action";
import { Franchies_Invoice_Singel_Get_for_Report_Api, Invoice_Singel_Get_for_Report_Api, } from "../../../helpers/backend_helper";
import * as report from '../../../Reports/ReportIndex'
import GlobalCustomTable from "../../../GlobalCustomTable";
import { changeCommonPartyDropDetailsAction } from "../../../store/Utilites/PartyDrodown/action";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import C_Report from "../../../components/Common/C_Report";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { CheckStockEntryForFirstTransaction, CheckStockEntryForFirstTransactionSuccess, CheckStockEntryforBackDatedTransaction, CheckStockEntryforBackDatedTransactionSuccess } from "../../../store/Inventory/StockEntryRedux/action";
import { Franchies_invoice_Calculate_Func, DiscountCaculationForFranchies, orderQtyOnChange, orderQtyUnit_SelectOnchange, postWithBasicAuth, RoundCalculationFunc, calculateCssBulkItem } from "./FranchiesInvoiceFunc";
import { FRANCHAISE_INVOICE_DELETE_API, FRANCHAISE_INVOICE_SAVE_API } from "../../../helpers/url_helper";
import { C_FilterSelect } from "../../Purchase/Order/FilterCustom";
import { getDriverList, getDriverListSuccess } from "../../../store/Administrator/DriverRedux/action";
import * as _act from "../../../store/actions";


const PageDetailsFunc = (subPageMode) => {
    let pageID = null;
    let listPath = null;

    if (subPageMode === url.FRANCHAISE_INVOICE) {
        pageID = pageId.FRANCHAISE_INVOICE;
        listPath = url.POS_INVOICE_LIST;
    }
    else if (subPageMode === url.CSS_BULK_INVOICE) {
        pageID = pageId.CSS_BULK_INVOICE;
        listPath = url.INVOICE_LIST_1;
    }
    return { pageID, listPath };
};


const Franchies_Invoice_Master = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const subPageMode = history.location.pathname;
    const PageDetails = PageDetailsFunc(subPageMode);
    const systemSetting = _cfunc.loginSystemSetting();
    const balanceAmountRef = useRef(null);
    const isCssBulk = subPageMode === url.CSS_BULK_INVOICE;
    const isRACompany = _cfunc.isRACompany();
    // Franchise/POS page: always show (as today). CSS Bulk: show only for RA.
    const showDiscountCol = !isCssBulk || isRACompany;
    const now = new Date();
    const date = now.toISOString().slice(0, 10); // e.g., 2024-11-29
    const time = now.toTimeString().slice(0, 8); // e.g., 13:32:54


    const fileds = {
        InvoiceDate: currentDate_ymd,
        Customer: "",
        VehicleNo: "",
        AdvanceAmount: "0",
        OrderID: 0,
        balanceAmount: 0,
        PaymentMode1: "Select", //while sending we check here label based
        PaymentMode1Amount: 0,
        PaymentMode2: "Select",
        PaymentMode2Amount: 0,
        DriverName: ""
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [orderItemDetails, setOrderItemDetails] = useState([])
    const [orderIDs, setOrderIDs] = useState('')
    const [editInvoiceData, setEditInvoiceData] = useState('')
    const isSubmittingRef = useRef(false);
    // for invoice page heder discount functionality useSate ************************************
    const [discountValueAll, setDiscountValueAll] = useState("");
    const [discountTypeAll, setDiscountTypeAll] = useState({ value: 2, label: " % " });
    const [discountDropOption] = useState([{ value: 1, label: "Rs" }, { value: 2, label: "%" }])
    const [changeAllDiscount, setChangeAllDiscount] = useState(false)

    const [saveBtnloading, setSaveBtnloading] = useState(false);
    const [btnMode, setBtnMode] = useState('');
    const [franchiesSaveApiRep, setFranchiesSaveApiRep] = useState({});
    const [franchiesUpdateApiRep, setFranchiesUpdateApiRep] = useState({});
    const [createdBy, seteditCreatedBy] = useState("");
    const [billAddr, setbillAddr] = useState('');
    const [shippAddr, setshippAddr] = useState('');
    const cssSaveWasLoadingRef = useRef(false);

    // ****************************************************************************

    const [modalCss] = useState(false);
    const [pageMode, setPageMode] = useState(mode.defaultsave);
    const [userPageAccessState, setUserAccState] = useState('');
    const {

        updateMsg,
        pageField,
        userAccess,
        gobutton_Add = { Status: false },
        vendorSupplierCustomer,
        makeIBInvoice,
        VehicleNumber,
        editData,
        commonPartyDropSelect,
        StockEnteryForFirstYear,
        StockEnteryForBackdated,
        SelectField,
        postMsg,
        invoiceSaveData,
        DriverList,
        supplierADDdropLoading,
        supplierAddress,
        saveBtnloading: reducerSaveBtnloading,           // 👈 ADD THIS LINE
        saveAndPdfBtnLoading: reducerSaveAndPdfLoading,  // 👈 ADD THIS LINE
    } = useSelector((state) => ({
        editData: state.InvoiceReducer.editData,
        updateMsg: state.InvoiceReducer.updateMsg,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        customer: state.CommonAPI_Reducer.customer,
        gobutton_Add: state.InvoiceReducer.gobutton_Add,
        vendorSupplierCustomer: state.CommonAPI_Reducer.vendorSupplierCustomer,
        VehicleNumber: state.VehicleReducer.VehicleList,
        makeIBInvoice: state.InvoiceReducer.makeIBInvoice,
        SelectField: state.PartyMasterBulkUpdateReducer.SelectField,
        commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
        StockEnteryForFirstYear: state.StockEntryReducer.StockEnteryForFirstYear,
        StockEnteryForBackdated: state.StockEntryReducer.StockEnteryForBackdated,
        invoiceSaveData: state.InvoiceReducer.invoiceSaveData,
        postMsg: state.InvoiceReducer.postMsg,
        DriverList: state.DriverReducer.DriverList,
        supplierADDdropLoading: state.CommonAPI_Reducer.supilerADDLoading,
        supplierAddress: state.CommonAPI_Reducer.supplierAddress,
        saveBtnloading: state.InvoiceReducer.saveBtnloading,           // 👈 ADD
        saveAndPdfBtnLoading: state.InvoiceReducer.saveAndPdfBtnLoading, // 👈 ADD
    }));

    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty("editValue")
    const values = { ...state.values }
    const { isError } = state;
    const { fieldLabel } = state;

    const releaseSubmit = () => {
        isSubmittingRef.current = false;
        setSaveBtnloading(false);
    };


    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(PageDetails.pageID));
        dispatch(GoButtonForinvoiceAddSuccess({ Status: false }))
        const jsonBody = {
            TypeID: 4,
            Company: _cfunc.loginCompanyID(),  // backend expects "Company"
        };

        dispatch(postSelect_Field_for_dropdown(jsonBody));
        return () => {
            dispatch(postOrderConfirms_API_Success({ Status: false }))
            dispatch(GoButtonForinvoiceAddSuccess({ Status: false }));
        }
    }, []);

    useEffect(() => {
        if (supplierAddress.length > 0) {
            setbillAddr(supplierAddress[0]);
            setshippAddr(supplierAddress[0]);
        }
    }, [supplierAddress]);

    useEffect(() => {

        // ✅ prevent initial / reset call
        if (!postMsg || !postMsg.Status) return;

        if (subPageMode === url.CSS_BULK_INVOICE) {
            setFranchiesSaveApiRep(postMsg);
            dispatch(invoiceSaveActionSuccess({ Status: false }));
            isSubmittingRef.current = false;
            return;
        }

        if (postMsg.StatusCode === 200) {

            customAlert({
                Type: 1,
                Message: postMsg.Message
            });

            history.push({
                pathname: PageDetails.listPath
            });

        } else {

            customAlert({
                Type: 3,
                Message: postMsg.Message
            });
            isSubmittingRef.current = false;
        }

        dispatch(invoiceSaveActionSuccess({ Status: false }));

    }, [postMsg]);

    useEffect(() => {
        if (!franchiesSaveApiRep || Object.keys(franchiesSaveApiRep).length === 0) return;

        if (
            franchiesSaveApiRep?.Status === true &&
            franchiesSaveApiRep?.StatusCode === 200
        ) {
            const rawId = franchiesSaveApiRep?.TransactionID;
            const invoiceId = Array.isArray(rawId) ? rawId[0] : rawId;
            const config = {
                editId: invoiceId,
                ReportType: _cfunc.isRACompany() ? report.RAinvoice : report.invoice,
                RowId: invoiceId,
                UserID: _cfunc.loginUserID(),
                Invoice_Identifier_ID:
                    franchiesSaveApiRep?.Invoice_Identifier_ID
            };

            // Order confirmation is only applicable when OrderID exists
            if (franchiesSaveApiRep?.OrderID) {
                try {
                    const jsonBody = {
                        OrderIDs: franchiesSaveApiRep.OrderID.toString()
                    };

                    dispatch(
                        postOrderConfirms_API({
                            jsonBody,
                            conform_saveInvoice: true
                        })
                    );
                } catch (error) { }
            }

            // Fetch PDF only when Save & Print was clicked
            if (franchiesSaveApiRep?.saveAndDownloadPdfMode) {
                try {
                    const printApi =
                        subPageMode === url.CSS_BULK_INVOICE
                            ? Invoice_Singel_Get_for_Report_Api
                            : Franchies_Invoice_Singel_Get_for_Report_Api;

                    dispatch(
                        getpdfReportdata(
                            printApi,
                            config
                        )
                    );
                } catch (error) { }
            }

            if (
                systemSetting.AutoEInvoice === "1" &&
                systemSetting.EInvoiceApplicable === "1"
            ) {
                try {
                    dispatch(Uploaded_EInvoiceAction(config));
                } catch (error) { }
            }

            customAlert({
                Type: 1,
                Message: franchiesSaveApiRep?.Message,
            });

            if (
                subPageMode === url.FRANCHAISE_INVOICE ||
                subPageMode === url.CSS_BULK_INVOICE
            ) {
                dispatch(
                    GoButtonForinvoiceAddSuccess({ Status: false })
                );

                if (
                    franchiesSaveApiRep?.saveAndDownloadPdfMode
                ) {
                    setTimeout(() => {
                        history.push({
                            pathname: PageDetails.listPath,
                            updatedRowBlinkId: invoiceId
                        });
                    }, 1500);
                } else {
                    history.push({
                        pathname: PageDetails.listPath,
                        updatedRowBlinkId: invoiceId
                    });
                }
            }

            if (!franchiesSaveApiRep?.saveAndDownloadPdfMode) {
                releaseSubmit();
            }
            setFranchiesSaveApiRep({});

        } else {

            dispatch(
                postOrderConfirms_API_Success({ Status: false })
            );

            setFranchiesSaveApiRep({});

            customAlert({
                Type: 4,
                Message: JSON.stringify(
                    franchiesSaveApiRep?.Message
                ),
            });
            releaseSubmit();
        }

    }, [franchiesSaveApiRep]);

    useEffect(() => {
        if (subPageMode !== url.CSS_BULK_INVOICE) return;

        if (reducerSaveBtnloading || reducerSaveAndPdfLoading) {
            cssSaveWasLoadingRef.current = true;
            return;
        }

        if (cssSaveWasLoadingRef.current) {
            isSubmittingRef.current = false;
            cssSaveWasLoadingRef.current = false;
        }
    }, [subPageMode, reducerSaveBtnloading, reducerSaveAndPdfLoading]);

    useEffect(() => {
        if (franchiesUpdateApiRep?.Status === true && franchiesUpdateApiRep?.StatusCode === 200) {

            setFranchiesUpdateApiRep({});
            releaseSubmit();
            customAlert({
                Type: 1,
                Message: "POSInvoice Update Successfully",
            });

            // Redirect to appropriate page based on subPageMode
            if (subPageMode === url.FRANCHAISE_INVOICE) {
                history.push({ pathname: PageDetails.listPath, updatedRowBlinkId: franchiesUpdateApiRep?.TransactionID });
            }

        } else if (franchiesUpdateApiRep?.Status === true || franchiesUpdateApiRep?.Status === false) {
            // Show error alert message with the JSON stringified postMsg.Message
            setFranchiesUpdateApiRep({});
            releaseSubmit();
            customAlert({
                Type: 4,
                Message: JSON.stringify(franchiesUpdateApiRep?.Message),
            });
        }
    }, [franchiesUpdateApiRep]);

    // Common Party Dropdown useEffect
    useEffect(() => {

        if (commonPartyDropSelect.value > 0) {
            dispatch(getVehicleList({ ..._cfunc.loginJsonBody(), "PartyID": commonPartyDropSelect.value }));
            dispatch(getDriverList({ ..._cfunc.loginJsonBody(), "PartyID": commonPartyDropSelect.value }));
            dispatch(GetVenderSupplierCustomer({ subPageMode, RouteID: "", "PartyID": commonPartyDropSelect.value }));
        }

        return () => {
            dispatch(GetVenderSupplierCustomerSuccess([]));
            dispatch(getVehicleListSuccess([]));
            dispatch(getDriverListSuccess([]));
            dispatch(CheckStockEntryForFirstTransactionSuccess({ status: false }))
            dispatch(CheckStockEntryforBackDatedTransactionSuccess({ status: false }))
            dispatch(changeCommonPartyDropDetailsAction({ forceDisable: false }))//change party drop-down restore state
            dispatch(invoiceSaveActionSuccess({ Status: false })); // Reset the status to false
            setOrderItemDetails([]);
            setState((i) => {
                const obj = { ...i }
                obj.values.Customer = "";
                obj.values.VehicleNo = "";
                obj.hasValid.Customer.valid = true;
                obj.hasValid.VehicleNo.valid = true;
                return obj
            })
        }
    }, [commonPartyDropSelect]);

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])


    useEffect(() => {

        if ((updateMsg.Status === true) && (updateMsg.StatusCode === 200) && !(modalCss)) {
            history.push({
                pathname: url.INVOICE_LIST_1,
            })
        } else if (updateMsg.Status === true && !modalCss) {
            dispatch(updateInvoiceActionSuccess({ Status: false }));
            customAlert({
                Type: 3,
                Status: true,
                Message: JSON.stringify(updateMsg.Message),
            })
        }
    }, [updateMsg, modalCss]);

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    useEffect(() => {

        if (makeIBInvoice.Status === true && makeIBInvoice.StatusCode === 200) {

            setState((i) => {
                const obj = { ...i }
                obj.values.Customer = makeIBInvoice.customer;
                obj.hasValid.Customer.valid = true;

                return obj
            })

            dispatch(makeIB_InvoiceActionSuccess({ Status: false }))
        }
    }, [makeIBInvoice]);

    useEffect(() => {
        if (gobutton_Add.Status === true && gobutton_Add.StatusCode === 200) {

            // NEW: make bound values match the onChange calculation (RA CSS Bulk only)
            if (subPageMode === url.CSS_BULK_INVOICE && isRACompany) {
                const gstObj = {
                    GSTIn_1: gobutton_Add.customer?.CustomerGSTIN,
                    GSTIn_2: _cfunc.loginUserGSTIN(),
                    IsSEZ: gobutton_Add.customer?.IsSEZ
                };
                gobutton_Add.Data.OrderItemDetails.forEach(item => calculateCssBulkItem(item, gstObj));
            }

            const OrderAmount = settingBaseRoundOffAmountFunc(gobutton_Add.Data.OrderItemDetails);
            const BalanceAmount = (Number(OrderAmount.sumOfGrandTotal) - Number(gobutton_Add.Data.AdvanceAmount)).toFixed(2);
            setState((i) => {
                const obj = { ...i }
                obj.values.Customer = gobutton_Add.customer;
                obj.hasValid.Customer.valid = true;
                obj.values.AdvanceAmount = gobutton_Add.customer.AdvanceAmount;
                obj.values.OrderID = gobutton_Add.customer.OrderIDs;
                obj.values.balanceAmount = BalanceAmount;
                return obj

            })

            setOrderItemDetails(gobutton_Add.Data.OrderItemDetails);

            // **********************************************************
            totalAmountCalcuationFunc(gobutton_Add.Data.OrderItemDetails)// show breadcrump tolat amount function//passs table array 
            //*********************************************************** */
            setOrderIDs(gobutton_Add.Data.OrderIDs)
            dispatch(_act.getSupplierAddress(gobutton_Add.customer.value));
            dispatch(GoButtonForinvoiceAddSuccess({ Status: false }))

        }
    }, [gobutton_Add]);

    useLayoutEffect(() => {

        if (((editData.Status === true) && (editData.StatusCode === 200))) {

            setState((i) => {
                const obj = { ...i }
                obj.values.Customer = editData.customer;
                obj.hasValid.Customer.valid = true;

                obj.values.OrderID = editData.customer.OrderID;
                obj.values.AdvanceAmount = editData.Data?.AdvanceAmount;
                obj.values.PaymentMode1 = editData.Data.PaymentMode1;
                obj.values.PaymentMode1Amount = editData.Data.PaymentMode1Amount;
                obj.values.PaymentMode2 = editData.Data.PaymentMode2;
                obj.values.PaymentMode2Amount = editData.Data.PaymentMode2Amount;


                obj.values.InvoiceDate = editData.Data?.InvoiceDate;
                obj.hasValid.InvoiceDate.valid = true;

                return obj
            })

            setPageMode(editData.pageMode);
            setEditInvoiceData(editData);
            setOrderItemDetails(editData.Data?.OrderItemDetails);
            seteditCreatedBy(editData?.Data?.CreatedBy)


            if (editData.pageMode === mode.edit) {
                dispatch(changeCommonPartyDropDetailsAction({ forceDisable: true }))//change party drop-down disable when edit/view
            };

            // **********************************************************
            totalAmountCalcuationFunc(editData.Data.OrderItemDetails)// show breadcrump tolat amount function//passs table array 
            //*********************************************************** */
            setOrderIDs(editData.Data.OrderIDs)
            dispatch(editInvoiceActionSuccess({ Status: false }))
        }

    }, [editData]);

    useLayoutEffect(() => {

        if ((VehicleNumber.length > 0) && editInvoiceData !== '' && pageMode == mode.edit) {
            const foundVehicle = VehicleNumber.find(i => editInvoiceData.Data.Vehicle === i.id);

            setState((i) => {
                const obj = { ...i }
                if (foundVehicle !== undefined) {
                    obj.values.VehicleNo = { value: foundVehicle.id, label: foundVehicle.VehicleNumber };
                    obj.hasValid.VehicleNo.valid = true;
                }
                return obj
            })
        }
    }, [VehicleNumber, editInvoiceData, pageMode]);

    useEffect(() => {

        if (changeAllDiscount) {
            const updatedOrderItemTable = orderItemDetails.map((item) => ({
                ...item,
                Discount: discountValueAll,
                DiscountType: discountTypeAll.value,
            }));

            // Perform calculations based on the updated values for each item
            updatedOrderItemTable.forEach((index1) => {
                const gstObj = {
                    GSTIn_1: values.Customer.CustomerGSTIN,
                    GSTIn_2: _cfunc.loginUserGSTIN(),
                    IsSEZ: values?.Customer?.IsSEZ
                };
                if (subPageMode === url.CSS_BULK_INVOICE) {
                    calculateCssBulkItem(index1, gstObj);
                } else {
                    DiscountCaculationForFranchies(index1, gstObj);
                }
            });
            totalAmountCalcuationFunc(updatedOrderItemTable);
            // Set the updated array as the new orderItemTable
            setOrderItemDetails([...updatedOrderItemTable]);
        }
    }, [changeAllDiscount, discountValueAll, discountTypeAll.value]);

    useEffect(() => { _cfunc.tableInputArrowUpDounFunc("#table_Arrow") },
        [orderItemDetails]);

    const CustomerDropdown_Options = vendorSupplierCustomer.map((index) => ({
        value: index.id,
        label: index.Name,
    }));

    const VehicleNumber_Options = VehicleNumber.map((index) => ({
        value: index.id,
        label: index.VehicleNumber,
    }));

    const handleFilterChange = (data) => {

        setState(prev => {
            const obj = { ...prev };
            obj.values.PaymentMode1 = data.PaymentMode1;
            obj.values.PaymentMode1Amount = Number(data.PaymentMode1Amount || 0);
            obj.values.PaymentMode2 = data.PaymentMode2;
            obj.values.PaymentMode2Amount = Number(data.PaymentMode2Amount || 0);
            return obj;
        });

    };

    const DriverOptions = (DriverList || []).map(d => ({
        value: d.id,
        label: d.Name,
    }));

    const pagesListColumns = [
        {
            text: "Item Name",
            dataField: "ItemName",
        },
        {//***************Quantity********************************************************************* */
            text: "Quantity/Unit",
            dataField: "",
            formatExtraData: { tableList: orderItemDetails },
            attrs: () => ({ 'data-label': "Quantity/Unit" }),
            formatter: (cellContent, index1, keys_, { tableList = [] }) => (
                <>
                    <div>
                        <CInput
                            type="text"
                            id={`OrderQty-${index1.id}`}
                            placeholder="Enter quantity"
                            cpattern={decimalRegx}
                            className="right-aligned-placeholder mb-1"
                            key={`OrderQty-${index1.id}`}
                            disabled={subPageMode === url.CSS_BULK_INVOICE}
                            autoComplete="off"
                            defaultValue={(isCssBulk && !isRACompany) ? index1.BaseUnitQuantity : index1.Quantity}
                            onChange={(event) => {
                                if (subPageMode === url.CSS_BULK_INVOICE) {
                                    const qty = Number(event.target.value || 0);

                                    index1.Quantity = qty;
                                    index1.BaseUnitQuantity = qty;   // ⭐ IMPORTANT

                                    calculateCssBulkItem(index1, {
                                        GSTIn_1: values.Customer.CustomerGSTIN,
                                        GSTIn_2: _cfunc.loginUserGSTIN(),
                                        IsSEZ: values?.Customer?.IsSEZ
                                    });

                                    setOrderItemDetails(prev => [...prev]);
                                } else {
                                    orderQtyOnChange(event, index1, {
                                        GSTIn_1: values.Customer.CustomerGSTIN,
                                        GSTIn_2: _cfunc.loginUserGSTIN(),
                                        IsSEZ: values?.Customer?.IsSEZ
                                    });
                                }

                                totalAmountCalcuationFunc(tableList);
                            }}
                        />
                    </div>
                    <div>
                        <div id="select">
                            <Select
                                classNamePrefix="select2-selection"
                                id={"ddlUnit"}
                                isDisabled={true}
                                defaultValue={index1.default_UnitDropvalue}
                                options={index1.UnitDetails.map(i => ({
                                    "label": i.UnitName,
                                    "value": i.MUnitID,
                                    "ConversionUnit": i.ConversionUnit,
                                    "Unitlabel": i.UnitName,
                                    "BaseUnitQuantity": i.BaseUnitQuantity,
                                    "BaseUnitQuantityNoUnit": i.BaseUnitQuantityNoUnit,
                                }))}
                                onChange={(event) => {
                                    index1.default_UnitDropvalue = event;
                                    index1.UnitName = event.Unitlabel;
                                    index1.BaseUnitQuantity = Number(index1.Quantity || 0);
                                    if (subPageMode === url.CSS_BULK_INVOICE) {
                                        index1.BaseUnitQuantity = Number(index1.Quantity || 0);
                                        calculateCssBulkItem(index1, {
                                            GSTIn_1: values.Customer.CustomerGSTIN,
                                            GSTIn_2: _cfunc.loginUserGSTIN(),
                                            IsSEZ: values?.Customer?.IsSEZ
                                        });
                                    } else {
                                        // Franchise / POS only
                                        orderQtyUnit_SelectOnchange(event, index1, {
                                            GSTIn_1: values.Customer.CustomerGSTIN,
                                            GSTIn_2: _cfunc.loginUserGSTIN(),
                                            IsSEZ: values?.Customer?.IsSEZ
                                        });
                                    }

                                    setOrderItemDetails(prev => [...prev]); // force re-render
                                    totalAmountCalcuationFunc(tableList);
                                }}
                            ></Select>
                        </div>
                    </div>
                    <div className="theme-font">
                        <span className="text-muted">Order-Qty :</span>
                        <samp>{index1.OrderQty}</samp>&nbsp;&nbsp;
                        <samp>{index1.UnitName}</samp>
                    </div>
                </>
            ),
        },
        ...(subPageMode === url.CSS_BULK_INVOICE
            ? [{
                text: "Rate",
                formatter: (_, index1) => index1.Rate,
            }]
            : [{
                text: "MRP",
                dataField: "MRPValue",
            }]),
        {//***************Discount********************************************************************* */
            text: "Discount/unit",
            dataField: "",
            hidden: !showDiscountCol,
            attrs: () => ({ 'data-label': "Discount/unit" }),
            formatExtraData: {
                tableList: orderItemDetails
            },
            headerFormatter: () => {
                return (
                    <div className="">
                        {orderItemDetails.length <= 0 ?
                            <div className="col col-3 mt-2">
                                <Label>Discount/unit</Label>
                            </div>
                            :
                            <div className="row">
                                <div className=" mt-n2 mb-n2">
                                    <Label>Discount/unit</Label>
                                </div>
                                <div className="col col-6" style={{ width: "100px" }}>
                                    <Select
                                        type="text"
                                        defaultValue={discountTypeAll}
                                        classNamePrefix="select2-selection"
                                        options={discountDropOption}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 55 })
                                        }}
                                        onChange={(e) => {

                                            setChangeAllDiscount(true);
                                            setDiscountTypeAll(e);
                                            setDiscountValueAll('');
                                        }}
                                    />
                                </div>
                                <div className="col col-6" style={{ width: "100px" }}>
                                    <CInput
                                        type="text"
                                        className="right-aligned-placeholder"
                                        cpattern={decimalRegx}
                                        placeholder="Enter discount value"
                                        value={discountValueAll}
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/^\.+/, '');
                                            e.target.value = e.target.value.replace(/^00+/, '0');
                                            let e_val = Number(e.target.value);

                                            if (discountTypeAll.value === 2) {// Discount type 2 represents "percentage"
                                                if (e_val >= 100) { // Limit the input to the range of 0 to 100
                                                    e.target.value = 100; // Set the input value to 100 if it exceeds 100
                                                } else if (!(e_val >= 0 && e_val < 100)) {
                                                    e.target.value = ""; // Clear the input value if it is less than 0
                                                }
                                            }

                                            setChangeAllDiscount(true);
                                            setDiscountValueAll(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                );
            },

            classes: () => "invoice-discount-row",
            formatter: (cellContent, index1, key, formatExtraData) => {
                let { tableList } = formatExtraData;

                if (!index1.DiscountType) { index1.DiscountType = discountTypeAll.value }

                const defaultDiscountTypelabel =
                    ((index1.DiscountType === "1") || (index1.DiscountType === 1)) ? discountDropOption[0] : discountDropOption[1];

                return (
                    <>
                        <div className="mb-2">
                            <div className="parent">
                                <div className="child">
                                    <label className="label">Type&nbsp;&nbsp;&nbsp;</label>
                                </div>
                                <div className="child">
                                    <Select
                                        id={`DicountType_${key}`}
                                        classNamePrefix="select2-selection"
                                        key={`DicountType_${key}-${index1.id}`}
                                        value={defaultDiscountTypelabel}
                                        options={discountDropOption}
                                        onChange={(selected) => {

                                            setChangeAllDiscount(false);

                                            index1.DiscountType = selected.value;

                                            const gstObj = {
                                                GSTIn_1: values.Customer.CustomerGSTIN,
                                                GSTIn_2: _cfunc.loginUserGSTIN(),
                                                IsSEZ: values?.Customer?.IsSEZ
                                            };

                                            if (subPageMode === url.CSS_BULK_INVOICE) {

                                                calculateCssBulkItem(index1, gstObj);
                                                setOrderItemDetails(prev => [...prev]);

                                            } else {

                                                DiscountCaculationForFranchies(index1, gstObj);

                                            }

                                            totalAmountCalcuationFunc(tableList);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="parent">
                                <div className="child">
                                    <label className="label">Value&nbsp;</label>
                                </div>
                                <div className="child">
                                    <CInput

                                        id={`Dicount_${key}-${index1.id}`}
                                        className="right-aligned-placeholder"
                                        type="text"
                                        placeholder="Enter discount value"
                                        value={index1.Discount}
                                        cpattern={decimalRegx}
                                        onChange={(e) => {

                                            e.target.value = e.target.value.replace(/^\.+/, '');
                                            e.target.value = e.target.value.replace(/^00+/, '0');
                                            let e_val = Number(e.target.value);


                                            if (index1.DiscountType === 2) {// Discount type 2 represents "percentage"
                                                if (e_val >= 100) { // Limit the input to the range of 0 to 100
                                                    e.target.value = 100; // Set the input value to 100 if it exceeds 100
                                                } else if (!(e_val >= 0 && e_val < 100)) {
                                                    e.target.value = ""; // Clear the input value if it is less than 0
                                                }
                                            }

                                            index1.Discount = e.target.value;
                                            setChangeAllDiscount(false);

                                            const gstObj = {
                                                GSTIn_1: values.Customer.CustomerGSTIN,
                                                GSTIn_2: _cfunc.loginUserGSTIN(),
                                                IsSEZ: values?.Customer?.IsSEZ
                                            };

                                            if (subPageMode === url.CSS_BULK_INVOICE) {
                                                calculateCssBulkItem(index1, gstObj);   // ✅ CSS BULK
                                                setOrderItemDetails(prev => [...prev]); // force re-render
                                            } else {
                                                DiscountCaculationForFranchies(index1, gstObj); // ✅ Franchise only
                                            }

                                            totalAmountCalcuationFunc(tableList);
                                        }}

                                    />
                                </div>
                            </div>
                        </div>
                        <div className="bottom-div">
                            <span className="theme-font text-muted">Amount:</span>
                            <samp className='text-black' id={`item-TotalAmount-${index1.id}`}>
                                {(index1?.ItemTotalAmount && _cfunc.amountCommaSeparateFunc((index1?.ItemTotalAmount).toFixed(2)) || 0)}
                            </samp>
                        </div>
                    </>
                );
            },
        },
    ];

    const totalAmountCalcuationFunc = (tableList = []) => {
        const calcalateGrandTotal = settingBaseRoundOffAmountFunc(tableList)
        const dataCount = tableList.length;
        const commaSeparateAmount = _cfunc.amountCommaSeparateFunc(Number(calcalateGrandTotal.sumOfGrandTotal).toFixed(2));
        dispatch(BreadcrumbShowCountlabel(`Count:${dataCount} currency_symbol ${commaSeparateAmount} weight ${(calcalateGrandTotal.sumOfWeightageTotal).toFixed(3)} kg`))
        setState(prev => {
            const v1 = { ...prev };
            const advance = Number(v1.values.AdvanceAmount || 0);   // latest updated value
            const balance = (Number(calcalateGrandTotal.sumOfGrandTotal) - advance).toFixed(2);
            v1.values.balanceAmount = balance;
            return v1;
        });

    }

    useEffect(() => {
        const jsonBody = JSON.stringify({
            "FromDate": values.InvoiceDate,
            "PartyID": commonPartyDropSelect.value
        });

        const jsonBodyForBackdatedTransaction = JSON.stringify({
            "TransactionDate": values.InvoiceDate,
            "PartyID": commonPartyDropSelect.value,

        });

        if (commonPartyDropSelect.value > 0) {
            dispatch(CheckStockEntryForFirstTransaction({ jsonBody }))
            dispatch(CheckStockEntryforBackDatedTransaction({ jsonBody: jsonBodyForBackdatedTransaction }))

        }
    }, [values.InvoiceDate, commonPartyDropSelect.value])

    useEffect(() => {
        if (StockEnteryForFirstYear.Status === true && StockEnteryForFirstYear.StatusCode === 400) {
            customAlert({
                Type: 3,
                Message: JSON.stringify(StockEnteryForFirstYear.Message),
            })
        }
    }, [StockEnteryForFirstYear])


    function InvoiceDateOnchange(y, v, e) {
        dispatch(GoButtonForinvoiceAddSuccess([]))

        onChangeDate({ e, v, state, setState })
    };

    function CustomerOnchange(hasSelect,) {

        setState((i) => {
            const v1 = { ...i }
            v1.values.Customer = hasSelect
            v1.hasValid.Customer.valid = true
            return v1
        })
    };
    const paymentModeOptions = [
        { value: "Select", label: "Select" },   // 👈 default option
        ...(SelectField || []).map((pm) => ({
            value: pm.id,
            label: pm.Name
        })),
    ];


    const sanitizePaymentMode = (mode) => {
        return mode === "Select" ? "" : mode;
    };

    const getPaymentType = ({ PaymentMode1, PaymentMode1Amount, PaymentMode2, PaymentMode2Amount }) => {

        let PaymentType = "";

        const pm1Selected = PaymentMode1 !== "Select" && PaymentMode1Amount > 0;
        const pm2Selected = PaymentMode2 !== "Select" && PaymentMode2Amount > 0;

        // If both selected → Partially
        if (pm1Selected && pm2Selected) {
            PaymentType = "Partially";
        }
        // If only payment mode 1 selected
        else if (pm1Selected && !pm2Selected) {
            PaymentType = PaymentMode1;
        }
        // If only payment mode 2 selected
        else if (!pm1Selected && pm2Selected) {
            PaymentType = PaymentMode2;
        }

        return PaymentType;
    };


    const ChallanSaveHandler = async (event, btnId) => {

        event.preventDefault();
        if (isSubmittingRef.current) return;   // 🔒 synchronous guard, blocks fast double-clicks
        isSubmittingRef.current = true;
        setBtnMode(btnId)
        setSaveBtnloading(true)
        const validMsg = []
        const franchiseItems = []        // existing structure
        const normalInvoiceItems = []   // for CSS bulk 

        // IsComparGstIn= compare Supplier and Customer are Same State by GSTIn Number
        // let IsComparGstIn = { GSTIn_1: values.Customer.CustomerGSTIN, GSTIn_2: _cfunc.loginUserGSTIN(), IsSEZ: values?.Customer?.IsSEZ }


        if (validMsg.length > 0) {
            customAlert({
                Type: 4,
                Message: validMsg,
            })
            releaseSubmit()

            return
        }
        if (!state.values.Customer?.value > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.customerIsRequired,
            })
            releaseSubmit()

            return
        }

        if (!billAddr?.value) {
            customAlert({
                Type: 4,
                Message: "Bill To Address is required"
            });
            releaseSubmit();
            return;
        }

        if (!shippAddr?.value) {
            customAlert({
                Type: 4,
                Message: "Shift To Address is required"
            });
            releaseSubmit();
            return;
        }
        // const calcalateGrandTotal = settingBaseRoundOffAmountFunc(orderItemDetails);

        // if (
        //     systemSetting?.EWayBillApplicable === "1" &&
        //     Number(calcalateGrandTotal?.sumOfGrandTotal) > Number(systemSetting?.AutoEwayBillminAmount) &&
        //     !values.VehicleNo?.value
        // ) {
        //     customAlert({
        //         Type: 11,
        //         Title: "Applicable for Auto E-way Bill",
        //         TitleMessage: `E-Way Bill is mandatory for invoices above ₹${systemSetting?.AutoEwayBillminAmount}. Please select a Vehicle Number to proceed.`,
        //     });

        //     setSaveBtnloading(false);
        //     return;
        // }
        // if (!values.DriverName?.value) {
        //     customAlert({
        //         Type: 4,
        //         Message: "Driver is required!",
        //     });
        //     setSaveBtnloading(false);
        //     return;
        // }

        // if (!values.VehicleNo?.value) {
        //     customAlert({
        //         Type: 4,
        //         Message: "Vehicle is required!",
        //     });
        //     setSaveBtnloading(false);
        //     return;
        // }

        if (subPageMode === url.CSS_BULK_INVOICE) {
            if (!(orderItemDetails?.length > 0)) {
                customAlert({
                    Type: 4,
                    Message: alertMessages.itemQtyIsRequired,
                });
                releaseSubmit();
                return;
            }
        } else {
            if (!(orderItemDetails.length > 0)) {
                customAlert({
                    Type: 4,
                    Message: alertMessages.itemQtyIsRequired,
                });
                releaseSubmit();
                return;
            }
        }

        const zeroRateItems = orderItemDetails.filter(
            item => Number(item.Rate || 0) === 0
        );

        if (zeroRateItems.length > 0) {
            const itemNames = zeroRateItems.map(i => i.ItemName).join(", ");

            customAlert({
                Type: 4,
                Message: `Rate cannot be zero for: ${itemNames}`
            });

            releaseSubmit();
            return;
        }

        let RoundCalculation = { RoundedAmount: 0 };

        if (subPageMode !== url.CSS_BULK_INVOICE) {
            RoundCalculation = RoundCalculationFunc(franchiseItems);
        }
        if (Number(values.AdvanceAmount) > RoundCalculation.RoundedAmount) {
            customAlert({
                Type: 4,
                Message: alertMessages.AdvanceAmount,
            })
            releaseSubmit()
            return
        }


        const PaymentMode1 = sanitizePaymentMode(values.PaymentMode1);
        const PaymentMode2 = sanitizePaymentMode(values.PaymentMode2);
        const PaymentMode1Amount = values.PaymentMode1Amount;
        const PaymentMode2Amount = values.PaymentMode2Amount;
        const balanceAmount = values.balanceAmount;


        if (Number(PaymentMode1Amount + PaymentMode2Amount) !== Number(balanceAmount) && subPageMode !== url.CSS_BULK_INVOICE) {
            customAlert({
                Type: 4,
                Message: "Payment Mode Amount must be equal to Balance Amount!",
            });
            releaseSubmit();
            return;
        }

        if ((PaymentMode1 && PaymentMode2 && PaymentMode1 === PaymentMode2) && (balanceAmount !== 0) && subPageMode !== url.CSS_BULK_INVOICE) {
            customAlert({
                Type: 4,
                Message: "Payment Mode 1 and Payment Mode 2 cannot be the same!"
            });
            releaseSubmit();
            return;
        }

        // 3️⃣ Amount entered → Dropdown must be selected
        if (subPageMode !== url.CSS_BULK_INVOICE && ((PaymentMode1 === "" && PaymentMode1Amount > 0) || (PaymentMode2 === "" && PaymentMode2Amount > 0))) {
            customAlert({
                Type: 4,
                Message: "If Amount is entered, Payment Mode must be selected!"
            });
            releaseSubmit();
            return;
        }

        try {
            let jsonBody = [];
            if (subPageMode === url.CSS_BULK_INVOICE) {
                let grandTotal = 0;
                orderItemDetails.forEach((index) => {
                    const itemAmount = Number(index.Amount);
                    grandTotal += itemAmount;

                    normalInvoiceItems.push({
                        Item: index.Item,
                        Quantity: Number(index.Quantity || 0).toFixed(3),
                        Rate: Number(index.Rate || 0).toFixed(2),
                        Unit: index.default_UnitDropvalue?.value,
                        BaseUnitQuantity: Number(index.BaseUnitQuantity).toFixed(3),
                        PreviousInvoiceBaseUnitQuantity: Number(index.BaseUnitQuantity).toFixed(3),
                        GSTPercentage: Number(index.GSTPercentage).toFixed(2),
                        GST: index.GST,
                        CGST: index.CGST,
                        CGSTPercentage: Number(index.CGSTPercentage).toFixed(2),
                        SGST: index.SGST,
                        SGSTPercentage: Number(index.SGSTPercentage).toFixed(2),
                        IGST: index.IGST,
                        IGSTPercentage: Number(index.IGSTPercentage).toFixed(2),
                        BasicAmount: Number(index.BasicAmount).toFixed(2),
                        GSTAmount: Number(index.GSTAmount).toFixed(2),
                        Amount: Number(index.Amount).toFixed(2),
                        DiscountType: index.DiscountType || "0",
                        Discount: Number(index.Discount) || 0,
                        DiscountAmount: Number(index.DiscountAmount),
                        TaxType: index.TaxType,
                        BatchCode: index.BatchCode,
                        BatchDate: index.BatchDate,
                        BatchID: index.BatchID || null,
                        SAPItemCode: index.SAPItemCode || "",
                        MRP: index.MRP_id,
                        MRPValue: index.MRPValue,
                        MUnitID: index.MUnitID || 0,
                        TrayQuantity: index.TrayQuantity || "",
                        LiveBatch: index.LiveBatch,
                    });
                });
                jsonBody = {
                    InvoiceData: [{
                        CreatedBy: _cfunc.loginUserID(),
                        UpdatedBy: _cfunc.loginUserID(),
                        BillTo: billAddr?.value || 0,
                        ShiftTo: shippAddr?.value || 0,
                        InvoiceDate: values.InvoiceDate,
                        Customer: values.Customer.value,
                        Party: _cfunc.loginSelectedPartyID(),
                        CustomerSAPCode: values.Customer.CustomerSAPCode || "",
                        SAPPartyCode: _cfunc.loginUserDetails()?.SAPPartyCode,
                        Send_CSS_to_CBM: false,
                        TCSAmount: "0.00",
                        GrandTotal: grandTotal.toFixed(2),
                        RoundOffAmount: 0,
                        Driver: values.DriverName?.value || "",
                        Vehicle: values.VehicleNo?.value || "",
                        StockEffect: false,
                        InvoiceItems: normalInvoiceItems,
                        InvoicesReferences: orderIDs
                            ? orderIDs.split(",").map(id => ({
                                Order: null,
                                Challan: Number(id)
                            }))
                            : []
                    }]
                };
            }
            if (pageMode === mode.edit) {
                const updateJsonBody = JSON.stringify([{
                    "DeletedTableAutoID": values.OrderID,
                    "ClientID": 0,
                    "ClientSaleID": values.OrderID,
                    "PartyID": values.Customer.PartyID,
                    "InvoiceDate": values.InvoiceDate,
                    "DeletedBy": _cfunc.loginUserID(),
                    "DeletedOn": `${date} ${time}`,
                    "ReferenceInvoiceID": null,
                    "isUpdate": true,
                    "UpdatedBy": _cfunc.loginUserID(),
                    "UpdatedOn": `${date} ${time}`,
                    "UpdatedInvoiceDetails": jsonBody
                }]);

                const updateApiResponse = await postWithBasicAuth({
                    jsonBody: updateJsonBody,
                    APIName: FRANCHAISE_INVOICE_DELETE_API,
                });
                setFranchiesUpdateApiRep(updateApiResponse)

            }
            else {
                // ⭐ If CSS BULK INVOICE → use saga
                if (subPageMode === url.CSS_BULK_INVOICE) {
                    if ((StockEnteryForFirstYear.Status === true && StockEnteryForFirstYear.StatusCode === 400) || (StockEnteryForBackdated.Status === true && StockEnteryForBackdated.StatusCode === 400)) {
                        customAlert({
                            Type: 3,
                            Message: (StockEnteryForFirstYear.Status === true && StockEnteryForFirstYear.StatusCode === 400) ? StockEnteryForFirstYear.Message : StockEnteryForBackdated.Message,
                        });
                        releaseSubmit();
                        return;
                    }
                    dispatch(invoiceSaveAction({
                        subPageMode,
                        jsonBody: JSON.stringify(jsonBody),
                        btnId,
                        saveAndDownloadPdfMode: btnId === "print"
                    }));

                }
            }
            setSaveBtnloading(false)

        } catch (e) {
            _cfunc.CommonConsole("invoice save Handler", e)
            releaseSubmit()

        }
        finally {
            setSaveBtnloading(false);
        }
    }

    const SaveHandler = async (event, btnId) => {

        event.preventDefault();
        if (isSubmittingRef.current) return;   // 🔒 synchronous guard, blocks fast double-clicks
        isSubmittingRef.current = true;
        setBtnMode(btnId)
        setSaveBtnloading(true)
        const validMsg = []
        const invoiceItems = []

        // IsComparGstIn= compare Supplier and Customer are Same State by GSTIn Number
        let IsComparGstIn = { GSTIn_1: values.Customer.CustomerGSTIN, GSTIn_2: _cfunc.loginUserGSTIN(), IsSEZ: values?.Customer?.IsSEZ }

        orderItemDetails.forEach((index) => {

            index.StockDetails.forEach((ele) => {

                if ((Number(ele.Qty) > 0) || (pageMode === mode.edit)) {

                    const calculate = Franchies_invoice_Calculate_Func(ele, index, IsComparGstIn)

                    invoiceItems.push({

                        "SaleDate": values.InvoiceDate,
                        "PartyID": _cfunc.loginPartyID(),
                        "ClientID": 0,
                        "ClientSaleItemID": 0,
                        "ClientSaleID": 0,
                        "ERPItemID": index.Item,
                        "ItemID": index.Item,
                        "IsMixItem": 0,
                        "MixItemId": null,
                        "ItemName": null,
                        "HSNCode": index.HSNCode,
                        "Quantity": Number(Number(ele.Qty).toFixed(3)),
                        "UnitID": (index.default_UnitDropvalue.value).toString(),

                        "DiscountType": index.DiscountType,
                        "DiscountValue": Number(Number(index.Discount).toFixed(2)) || 0,
                        "DiscountAmount": Number(Number(calculate.disCountAmt).toFixed(2)),

                        "MRP": parseFloat(ele.MRP),
                        "Rate": Number(Number(ele.Rate).toFixed(2)),
                        "Amount": Number(Number(calculate.ItemTotalAmount).toFixed(2)),
                        "BasicAmount": Number(Number(calculate.taxableAmount).toFixed(2)),

                        "GSTRate": parseFloat(ele.GST),
                        "GSTAmount": Number(Number(calculate.GST_Amount).toFixed(2)),

                        "CGSTRate": parseFloat(calculate.CGST_Percentage),
                        "CGSTAmount": Number(Number(calculate.CGST_Amount).toFixed(2)),

                        "SGSTRate": parseFloat(calculate.SGST_Percentage),
                        "SGSTAmount": Number(Number(calculate.SGST_Amount).toFixed(2)),

                        "IGSTRate": Number(Number(calculate.IGST_Percentage).toFixed(2)),
                        "IGSTAmount": Number(Number(calculate.IGST_Amount).toFixed(2)),
                    })
                }
            })

        })

        if (validMsg.length > 0) {
            customAlert({
                Type: 4,
                Message: validMsg,
            })
            releaseSubmit()

            return
        }
        if (!state.values.Customer?.value > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.customerIsRequired,
            })
            releaseSubmit()

            return
        }

        if (!(invoiceItems.length > 0)) {
            customAlert({
                Type: 4,
                Message: alertMessages.itemQtyIsRequired,
            })
            releaseSubmit()

            return
        }


        const RoundCalculation = RoundCalculationFunc(invoiceItems);
        if (Number(values.AdvanceAmount) > RoundCalculation.RoundedAmount) {
            customAlert({
                Type: 4,
                Message: alertMessages.AdvanceAmount,
            })
            releaseSubmit()
            return
        }


        const PaymentMode1 = sanitizePaymentMode(values.PaymentMode1);
        const PaymentMode2 = sanitizePaymentMode(values.PaymentMode2);
        const PaymentMode1Amount = values.PaymentMode1Amount;
        const PaymentMode2Amount = values.PaymentMode2Amount;
        const balanceAmount = values.balanceAmount;


        if ((Number(PaymentMode1Amount) + Number(PaymentMode2Amount)) !== Number(balanceAmount)) {
            customAlert({
                Type: 4,
                Message: "Payment Mode Amount must be equal to Balance Amount!",
            });
            releaseSubmit();
            return;
        }

        if ((PaymentMode1 && PaymentMode2 && PaymentMode1 === PaymentMode2) && (balanceAmount !== 0)) {
            customAlert({
                Type: 4,
                Message: "Payment Mode 1 and Payment Mode 2 cannot be the same!"
            });
            releaseSubmit();
            return;
        }

        // 3️⃣ Amount entered → Dropdown must be selected
        if ((PaymentMode1 === "" && PaymentMode1Amount > 0) || (PaymentMode2 === "" && PaymentMode2Amount > 0)) {
            customAlert({
                Type: 4,
                Message: "If Amount is entered, Payment Mode must be selected!"
            });
            releaseSubmit();
            return;
        }

        try {
            let jsonBody = [{
                "ClientID": 0,
                "ClientSaleID": 0,
                "DivisionID": _cfunc.loginPartyID(),
                "MacID": null,
                "SaleDate": values.InvoiceDate,
                "CustomerID": values.Customer.value,
                "Mobile": '',
                "PaymentType": getPaymentType(values),
                "DiscountAmount": RoundCalculation.DiscountAmount,
                "TotalAmount": RoundCalculation.TotalAmount,
                "NetAmount": RoundCalculation.NetAmount,
                "RoundedAmount": RoundCalculation.RoundedAmount,
                "RoundOffAmount": RoundCalculation.RoundOffAmount,
                "CreatedBy": _cfunc.loginUserID(),
                "CreatedOn": `${date} ${time}`,
                "UpdatedBy": _cfunc.loginUserID(),
                "UpdatedOn": `${date} ${time}`,
                "IsDeleted": 0,
                "ReferenceInvoiceID": null,
                "Description": null,
                "AdvanceAmount": (Number(values.AdvanceAmount)).toFixed(2),
                "PaymentMode1": PaymentMode1,
                "PaymentMode1Amount": Number(PaymentMode1Amount),
                "PaymentMode2": PaymentMode2,
                "PaymentMode2Amount": Number(PaymentMode2Amount),
                "SaleItems": invoiceItems,
                "SPOSInvoicesReferences": [
                    {
                        "Order": values.OrderID
                    }
                ],
            }]

            if (pageMode === mode.edit) {
                const updateJsonBody = JSON.stringify([{
                    "DeletedTableAutoID": values.OrderID,
                    "ClientID": 0,
                    "ClientSaleID": values.OrderID,
                    "PartyID": values.Customer.PartyID,
                    "InvoiceDate": values.InvoiceDate,
                    "DeletedBy": _cfunc.loginUserID(),
                    "DeletedOn": `${date} ${time}`,
                    "ReferenceInvoiceID": null,
                    "isUpdate": true,
                    "UpdatedBy": _cfunc.loginUserID(),
                    "UpdatedOn": `${date} ${time}`,
                    "UpdatedInvoiceDetails": jsonBody
                }]);

                const updateApiResponse = await postWithBasicAuth({
                    jsonBody: updateJsonBody,
                    APIName: FRANCHAISE_INVOICE_DELETE_API,
                });
                setFranchiesUpdateApiRep(updateApiResponse)

            }
            else {

                const saveApiRespone = await postWithBasicAuth({
                    jsonBody: jsonBody,
                    btnId: btnId,
                    OrderID: values.OrderID,
                    APIName: FRANCHAISE_INVOICE_SAVE_API,
                });
                saveApiRespone.saveAndDownloadPdfMode = btnId === "print";
                setFranchiesSaveApiRep(saveApiRespone)
            }

            setSaveBtnloading(false)

        } catch (e) {
            _cfunc.CommonConsole("invoice save Handler", e)
            releaseSubmit()

        }
        finally {
            setSaveBtnloading(false);
        }
    }

    const isSaveLoading = subPageMode === url.CSS_BULK_INVOICE ? reducerSaveBtnloading : (saveBtnloading && btnMode !== "print");
    const isPrintLoading = subPageMode === url.CSS_BULK_INVOICE
        ? reducerSaveAndPdfLoading
        : (saveBtnloading && btnMode === "print");

    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
                <C_Report />

                <div className="page-content" >

                    <form noValidate>
                        <Col className="px-2 mb-1 c_card_filter header text-black" sm={12}>
                            <Row>

                                {/* Invoice Date */}
                                <Col sm="2" className="mb-1">
                                    <Label className="form-label mt-2">{fieldLabel.InvoiceDate}</Label>
                                    <C_DatePicker
                                        name="InvoiceDate"
                                        value={values.InvoiceDate}
                                        disabled={(orderItemDetails.length > 0 || pageMode === "edit")}
                                        onChange={InvoiceDateOnchange}
                                    />
                                    {isError.InvoiceDate && (
                                        <div className="text-danger small mt-1">{isError.InvoiceDate}</div>
                                    )}
                                </Col>

                                {/* Customer */}
                                <Col className="mb-1" sm={subPageMode === url.CSS_BULK_INVOICE ? 3 : 4}
                                    md={subPageMode === url.CSS_BULK_INVOICE ? 3 : 4}
                                    lg={subPageMode === url.CSS_BULK_INVOICE ? 3 : 4}>
                                    <Label className="form-label mt-2">{fieldLabel.Customer}</Label>
                                    <Select
                                        name="Customer"
                                        value={values.Customer}
                                        isSearchable
                                        isDisabled={orderItemDetails.length > 0}
                                        options={CustomerDropdown_Options}
                                        onChange={CustomerOnchange}
                                        classNamePrefix="dropdown"
                                        styles={{ menu: p => ({ ...p, zIndex: 3 }) }}
                                    />
                                    {isError.Customer && (
                                        <div className="text-danger small mt-1">{isError.Customer}</div>
                                    )}
                                </Col>
                                {subPageMode === url.CSS_BULK_INVOICE && (
                                    <Col sm="2" className="mb-1 mt-2">
                                        <Label>Billing Address</Label>
                                        <C_Select
                                            value={billAddr}
                                            options={supplierAddress}
                                            onChange={(e) => setbillAddr(e)}
                                            isLoading={supplierADDdropLoading}
                                        />
                                    </Col>
                                )}
                                {subPageMode === url.CSS_BULK_INVOICE && (
                                    <Col sm="2" className="mb-1 mt-2">
                                        <Label>Shipping Address</Label>
                                        <C_Select
                                            value={shippAddr}
                                            options={supplierAddress}
                                            onChange={(e) => setshippAddr(e)}
                                            isLoading={supplierADDdropLoading}
                                        />
                                    </Col>
                                )}

                                {/* Vehicle No */}
                                {subPageMode !== url.CSS_BULK_INVOICE && (
                                    <Col sm="2" className="mb-1">
                                        <Label className="form-label mt-2">{fieldLabel.VehicleNo}</Label>
                                        <Select
                                            name="VehicleNo"
                                            value={values.VehicleNo}
                                            isSearchable
                                            options={VehicleNumber_Options}
                                            onChange={(hasSelect, evn) =>
                                                onChangeSelect({ hasSelect, evn, state, setState })
                                            }
                                            classNamePrefix="dropdown"
                                            styles={{ menu: p => ({ ...p, zIndex: 3 }) }}
                                        />
                                        {isError.VehicleNo && (
                                            <div className="text-danger small mt-1">{isError.VehicleNo}</div>
                                        )}
                                    </Col>
                                )}
                                {/* {subPageMode === url.CSS_BULK_INVOICE && (
                                    <Col sm="2" className="mb-1">
                                        <Label className="form-label mt-2" style={{ width: "90px" }}>{fieldLabel.DriverName}</Label>
                                        <Select
                                            name="DriverName"
                                            value={values.DriverName}
                                            options={DriverOptions}
                                            onChange={(hasSelect) => {
                                                setState(i => ({
                                                    ...i,
                                                    values: { ...i.values, DriverName: hasSelect }
                                                }));
                                            }}
                                        />
                                    </Col>
                                )} */}

                                {/* Advance Amount */}
                                {subPageMode !== url.CSS_BULK_INVOICE &&
                                    <Col sm="2" className="mb-1">
                                        <Label className="form-label mt-2">{fieldLabel.AdvanceAmount}</Label>
                                        <Input
                                            type="text"
                                            value={values.AdvanceAmount}
                                            disabled={true}
                                        />
                                        {isError.AdvanceAmount && (
                                            <div className="text-danger small mt-1">{isError.AdvanceAmount}</div>
                                        )}
                                    </Col>
                                }
                                {subPageMode !== url.CSS_BULK_INVOICE &&
                                    <Col sm="2" className="mb-1">
                                        <Label className="form-label mt-2">Balance Amount</Label>
                                        <C_FilterSelect
                                            paymentModeOptions={paymentModeOptions}
                                            onFilterChange={handleFilterChange}
                                            subPageMode={subPageMode}
                                            Input_ref={balanceAmountRef}
                                            value={state.values.balanceAmount}
                                            Input_ID={"balanceAmount_Input"}
                                            pm1={state.values.PaymentMode1}
                                            pm1Amt={state.values.PaymentMode1Amount}
                                            pm2={state.values.PaymentMode2}
                                            pm2Amt={state.values.PaymentMode2Amount}
                                            showInput={true}
                                            pageMode={pageMode}
                                        />
                                    </Col>
                                }
                            </Row>
                        </Col>



                        <div className="mb-1">
                            <GlobalCustomTable
                                keyField={"id"}
                                data={orderItemDetails}
                                columns={pagesListColumns}
                                id="table_Arrow"
                                noDataIndication={
                                    <div className="text-danger text-center ">
                                        Items Not available
                                    </div>
                                }
                                onDataSizeChange={(e) => {
                                    _cfunc.tableInputArrowUpDounFunc("#table_Arrow")
                                }}
                            />
                        </div>

                        {(orderItemDetails.length > 0) &&
                            <SaveButtonDraggable>
                                <SaveButton
                                    loading={isSaveLoading}
                                    pageMode={pageMode}
                                    userAcc={userPageAccessState}
                                    editCreatedBy={createdBy}
                                    onClick={(e) => {
                                        if (isSubmittingRef.current) return;
                                        subPageMode === url.CSS_BULK_INVOICE ? ChallanSaveHandler(e, "save") : SaveHandler(e, "save")
                                    }}
                                    forceDisabled={isSaveLoading || !StockEnteryForFirstYear.Data}
                                    module={"Invoice"}
                                />
                                {(pageMode === mode.defaultsave) &&
                                    <SaveAndDownloadPDF
                                        loading={isPrintLoading}
                                        pageMode={pageMode}
                                        userAcc={userPageAccessState}
                                        onClick={(e) => {
                                            if (isSubmittingRef.current) return;
                                            subPageMode === url.CSS_BULK_INVOICE ? ChallanSaveHandler(e, "print") : SaveHandler(e, "print")
                                        }}
                                        forceDisabled={isPrintLoading || !(StockEnteryForFirstYear.Data)}
                                        module={"Invoice"}
                                    />
                                }
                            </SaveButtonDraggable>
                        }
                    </form>
                </div >

            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
};

export default Franchies_Invoice_Master

